import React from 'react';
import PropTypes from 'prop-types';
import Video from './video';
import { NextArrow, PreviousArrow, BasicCarousel } from 'components';
import { breakPoints, BPOINT } from 'constants/breakpoints';
import STRINGS from 'constants/strings';

const VideoCarousel = ({ items, pageType }) => {
    const renderItems = () =>
        items.map((item, i) => <Video item={item} key={i} />);

    const settings = {
        nextArrow: (
            <NextArrow
                pageType={pageType}
                className="d-flex v-100 align-items-center"
            />
        ),
        prevArrow: (
            <PreviousArrow
                pageType={pageType}
                className="d-flex v-100 align-items-center"
            />
        ),
        dots: true,
        infinite: true,
        speed: 500,
        lazyLoad: true,
        slidesToShow: 3,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: breakPoints[BPOINT.small].max,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };

    return (
        <div className="container-fluid pt-5" style={{ paddingBottom: '8rem' }}>
            <div className="row justify-content-center mx-lg-auto mx-1">
                <div className="col-lg-9 col-md-10 col-12">
                    <h3 className="pb-3">
                        {STRINGS.VIEW_MORE_VIDEOS}
                    </h3>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-9 col-md-10 col-12">
                    <BasicCarousel
                        className="video-carousel"
                        settings={settings}
                        render={() => renderItems()}
                    />
                </div>
            </div>
        </div>
    );
};

VideoCarousel.propTypes = {
    pageType: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            image: PropTypes.string
        })
    )
};

export default VideoCarousel;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/carousels/video-carousel/video-carousel.jsx